<template>
  <a-upload
    name="file"
    :showUploadList="false"
    accept="image/jpeg,image/png,image/jpg"
    list-type="picture-card"
    class="w-0100 h-0100"
    :action="uploadCp.baseUrl"
    :headers="uploadCp.header"
    @change="onFileUpload"
    :beforeUpload="onBeforeUpload"
  >
    <div class="relative w-0100 h-0100">
      <slot>
      </slot>
    </div>
  </a-upload>
</template>

<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { LeftOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import config from "@/config";
import { getToken } from "@/libs/util";
const baseUrl = config.baseUrl[process.env.VUE_APP_type];
const oss = config.oss[process.env.VUE_APP_type];

const $route = inject("$route");
const $Modal = inject("$Modal");
const $router = inject("$router");
const _lodash = inject("_lodash");

export default {
  components: {},
  setup(props, {emit}) {
    let uploadCp = reactive({
      baseUrl: baseUrl + "upload/alone",
      header: {
        apiAuth: getToken()
      }
    });
    const onBeforeUpload = () => {};
    const onFileUpload = (info) => {
      if (info.file.status === "done") {
        emit('success', info.file.response.data)
      } else if (info.file.status === "error") {
        message.error("图片上传失败！");
      } else if (info.file.status === "removed") {
        console.log("removed", info);
      }
    };
    const onPreview = () => {};

    return {
      uploadCp,
      onBeforeUpload,
      onFileUpload,
      onPreview
    };
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-upload.ant-upload-select-picture-card {
  width: 100%;
  height: 100%;
}
</style>
